// Blocks, mutes, reports, commendations and reliability: what both sides agree on.

/** Commendation tags: kind words you can leave a teammate after a fight. */
export const COMMEND_TAGS = [
  { id: 'healer', label: 'Great healer', icon: '✚' },
  { id: 'tank', label: 'Steady shield', icon: '🛡' },
  { id: 'caster', label: 'Sharp caster', icon: '🔥' },
  { id: 'quick', label: 'Quick hands', icon: '🗡' },
  { id: 'kind', label: 'Good company', icon: '☺' },
] as const;
export type CommendTag = typeof COMMEND_TAGS[number]['id'];
export const isCommendTag = (t: unknown): t is CommendTag => COMMEND_TAGS.some(x => x.id === t);
/** A sensible first suggestion for someone's job. */
export const tagForJob = (job: string | undefined): CommendTag => job === 'cleric' ? 'healer' : job === 'knight' ? 'tank' : job === 'wizard' ? 'caster' : job === 'rogue' ? 'quick' : 'kind';

export const REPORT_REASONS = [
  { id: 'harassment', label: 'Harassment or bullying' },
  { id: 'hate', label: 'Hateful language' },
  { id: 'spam', label: 'Spam or scams' },
  { id: 'cheating', label: 'Cheating or exploits' },
  { id: 'name', label: 'Inappropriate name' },
  { id: 'other', label: 'Something else' },
] as const;
export type ReportReason = typeof REPORT_REASONS[number]['id'];
export const isReportReason = (r: unknown): r is ReportReason => REPORT_REASONS.some(x => x.id === r);

/** Someone's standing, as others see it. */
export interface Rep { commends: number; tags: Partial<Record<CommendTag, number>>; done: number; left: number }
export const emptyRep = (): Rep => ({ commends: 0, tags: {}, done: 0, left: 0 });
/** "Finished 48 of 50 fights" (null until they've fought a few). */
export const reliability = (r: Rep): string | null => r.done + r.left < 3 ? null : `Finished ${r.done} of ${r.done + r.left} fights`;

/** The little card you see when you check on someone. */
export interface PlayerCard { char: number; name: string; faction: number; job: string; level: number; rep: Rep; friend: boolean; blocked: boolean; zone: string }
